import { render, staticRenderFns } from "./ConfirmPaymentMethod.vue?vue&type=template&id=78b12b7f&scoped=true"
import script from "./ConfirmPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ConfirmPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b12b7f",
  null
  
)

export default component.exports